module.exports = __webpack_public_path__ + "benefit-build2.5815dac.png";